<div class="return-review-dashboard">
  @if (irsFilter) {
<div class="return-review-dashboard__filters gt-filter-container">
    <div class="filter-col filter-refresh">
      @if (irsFilterLoading) {
<i
       
        class="fa fa-spinner fa-spin gt-refresh"
        aria-hidden="true"
      ></i>
}
      @if (!irsFilterLoading) {
<i
       
        class="fa fa-refresh gt-refresh"
        role="button"
        tabindex="0"
        title="Reload IRS Submissions"
        aria-label="Reload IRS Submissions"
        (click)="irsFilterReload.emit()"
        (keyup.enter)="irsFilterReload.emit()"
      ></i>
}
    </div>
    @if (!irsFilterLoading) {
<div class="filter-col filter-dropdown">
      <div
        df-select-single
        [attr.aria-label]="irsFilter.label"
        [filter]="irsFilter"
        [showPlaceholderLabel]="!irsFilterUserPicked"
        (filterChange)="irsFilterChange.emit($event)"
      ></div>
    </div>
}
  </div>
}

  <div class="return-review-dashboard__toolbar">
    <button
      type="button"
      class="btn btn-default btn-sm"
      [disabled]="exporting || loading"
      (click)="exportRequested.emit()"
    >
      <i
        class="fa"
        [ngClass]="exporting ? 'fa-spinner fa-spin' : 'fa-download'"
        aria-hidden="true"
      ></i>
      Export Return Review
    </button>
    <button
      type="button"
      class="btn btn-default btn-sm return-review-dashboard__refresh"
      [disabled]="loading || refreshing"
      (click)="refreshRequested.emit()"
      title="Refresh dashboard"
      aria-label="Refresh dashboard"
    >
      <i class="fa" [ngClass]="refreshing ? 'fa-spinner fa-spin' : 'fa-refresh'" aria-hidden="true"></i>
    </button>
  </div>

  @if (loading) {

    <div class="return-review-dashboard__state">
      <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
      Loading Return Review dashboard…
    </div>
  
} @else {

    @if (loadError) {

      <div class="return-review-dashboard__state return-review-dashboard__state--error">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ loadError }}
      </div>
    
} @else {

      @if (rows.length > 0) {
<div
        class="return-review-dashboard__table-scroll"
        [class.return-review-dashboard__table-scroll--refreshing]="refreshing"
       
      >
        <table class="return-review-dashboard__table">
          <thead>
            <tr>
              <th scope="col">Screen Name</th>
              <th scope="col">Error Status</th>
              <th scope="col">Review Status</th>
              <th scope="col">Reviewer Comments</th>
              <th scope="col">Reviewed Timestamp</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track trackByStep($index, row)) {
<tr
             
              class="return-review-dashboard__row"
              [class.return-review-dashboard__row--outstanding]="row.outstanding"
              tabindex="0"
              role="button"
              [attr.aria-label]="'Open ' + row.screenName"
              (click)="onRowClick(row)"
              (keydown)="onRowKeydown($event, row)"
            >
              <td class="return-review-dashboard__screen">{{ row.screenName }}</td>
              <td
                class="return-review-dashboard__error"
                [class.return-review-dashboard__error--has-error]="row.errorStatus === 'Error'"
              >
                {{ row.errorStatus }}
              </td>
              <td
                class="return-review-dashboard__status"
                [class.return-review-dashboard__status--pending]="row.step.STEP_STATUS === 'PENDING'"
                [class.return-review-dashboard__status--resolved]="row.step.STEP_STATUS === 'RESOLVED' || row.step.STEP_STATUS === 'IGNORED'"
                [class.return-review-dashboard__status--failed]="row.step.STEP_STATUS === 'FAILED'"
              >
                {{ row.reviewStatus }}
              </td>
              <td class="return-review-dashboard__comments">{{ row.reviewerComments }}</td>
              <td class="return-review-dashboard__timestamp">{{ row.reviewedTimestamp }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
} @else {

        <div class="return-review-dashboard__state">
          No Return Review screens are available for this submission.
        </div>
      
}

      
    
}

    
  
}

  
</div>
